<template>
    <span v-if="fight.fightNumber">#{{ fight.fightNumber }}</span>
    <span v-else>#{{ fightIndex + 1 }}</span>
</template>

<script setup lang="ts">
    defineProps<{
        fightIndex: number;
        fight: {
            fightNumber: number | null;
        };
    }>();
</script>

<style scoped></style>
